import React, { useEffect, useRef } from "react";

export interface PendingAction {
  type: string;
  remainingPercentage?: number;
  message: string;
}

const PendingTicker: React.FC<{ actions: PendingAction[] }> = ({ actions }) => {
  const trackRef = useRef<HTMLDivElement>(null);
  const animRef = useRef<Animation | null>(null);

  useEffect(() => {
    const el = trackRef.current;
    if (!el || !actions.length) return;

    const totalChars = actions.reduce((n, a) => n + a.message.length + 12, 0);
    const duration = Math.max(15, totalChars * 0.18) * 1000; // ms

    animRef.current = el.animate(
      [{ transform: "translateX(0)" }, { transform: "translateX(-50%)" }],
      { duration, iterations: Infinity, easing: "linear" }
    );

    return () => animRef.current?.cancel();
  }, [actions]);

  if (!actions.length) return null;

  const renderItems = (hidden = false) => (
    <div
      className="d-flex flex-shrink-0"
      style={{ minWidth: "100vw" }}
      aria-hidden={hidden}
    >
      {actions.map((a, i) => (
        <span
          key={`${a.type}-${i}`}
          className="d-inline-flex align-items-center gap-2 px-4 text-nowrap small text-light"
          style={{ fontSize: 13 }}
        >
          <i className="bx bxs-circle text-light " style={{ fontSize:6 }} />
          {a.message}
          <span className="badge rounded-pill bg-danger text-light fw-semibold" style={{ fontSize: 12}}>
            {a.remainingPercentage ? `${a.remainingPercentage} % left` : ""}
          </span>
        </span>
      ))}
    </div>
  );

  return (
<>
  <div
    className="d-flex align-items-center overflow-hidden bg-dark "
    style={{
      position: "fixed",
      top: 90,                                             
      left: 250,             
      right: 0,
      zIndex: 1020,
      margin: "0 12px",
    }}
  >
    <div className="flex-shrink-0 bg-danger text-white fw-bold small px-3 py-2">
      PENDING
    </div>

    <div
      className="flex-grow-1 overflow-hidden"
      onMouseEnter={() => animRef.current?.pause()}
      onMouseLeave={() => animRef.current?.play()}
    >
      <div ref={trackRef} className="d-flex" style={{ width: "max-content" }}>
        {renderItems()}
        {renderItems(true)}
      </div>
    </div>
  </div>

  <div style={{ height: 44 }} />
</>
  );
};

export default PendingTicker;